import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authHeader = () => {
  const t = localStorage.getItem("aiude_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const api = axios.create({ baseURL: API });

export const STAGES = [
  { id: "intent", title: "Intent", subtitle: "Capture" },
  { id: "specification", title: "Specification", subtitle: "Structured" },
  { id: "geometry", title: "Geometry", subtitle: "Proposed" },
  { id: "materials", title: "Materials", subtitle: "Requirements" },
  { id: "simulation", title: "Simulation", subtitle: "Analysis" },
  { id: "validation", title: "Validation", subtitle: "Review" },
  { id: "manufacturing", title: "Manufacturing", subtitle: "Outputs" },
];
